// extracted by mini-css-extract-plugin
export var active = "Slider-module--active--ca467";
export var arrow = "Slider-module--arrow--c74cb";
export var core = "Slider-module--core--8f125";
export var dots = "Slider-module--dots--cd576";
export var hidden = "Slider-module--hidden--b6b4d";
export var overflow = "Slider-module--overflow--ff4e2";
export var slidesWrapper = "Slider-module--slides-wrapper--4d7fa";